import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import logo from "../../assets/logo/Logo-BlueZone.png";
import aboutUs from "../../assets/images/Rectangle 30.png";
import check from "../../assets/icons/mdi_check.svg";
import fast from "../../assets/icons/fast-ic.svg";
import fastClock from "../../assets/icons/fast-ic-clock.svg";
import group from "../../assets/icons/Group.svg";
import handTouch from "../../assets/icons/hand-touch-ic.svg";
import calendar from "../../assets/icons/calendar-ic.svg";
import moneyOnline from "../../assets/icons/Money-Online.svg";
import creditCard from "../../assets/icons/fa_credit-card.svg";
import listCheck from "../../assets/icons/ant-design_file-protect-outlined.svg";
import smile from "../../assets/icons/Smile.svg";
import info from "../../assets/icons/i.svg";
import vinaphone from "../../assets/logo-partner/vinaphone.png";
import trueMoney from "../../assets/logo-partner/true-money.png";
import feCredit from "../../assets/logo-partner/fe-credit.png";
import vib from "../../assets/logo-partner/vib-blue.png";
import lotte from "../../assets/logo-partner/lotte.png";
import tpbank from "../../assets/logo-partner/tpbank.png";
import bidv from "../../assets/logo-partner/bidv.png";
import f88 from "../../assets/logo-partner/f88.jpg";
import mobifone from "../../assets/logo-partner/mobifone.png";
import techcombank from "../../assets/logo-partner/techcombank.png";
import tpfico from "../../assets/logo-partner/tpfico.png";
import viettel from "../../assets/logo-partner/viettel.png";
import borrow from "../../assets/images/borrow.png";
import listForm from "../../assets/icons/form-icon.svg";
import telesale from "../../assets/icons/Telesale-icon.svg";
import finishForm from "../../assets/icons/finish-form-icon.svg";
import App from "../../assets/icons/APp-icon.svg";
import elipsePurple from "../../assets/icons/ellipse-purple.svg";
import elipseGreen from "../../assets/icons/ellipse-green.svg";
import elipsePink from "../../assets/icons/ellipse-pink.svg";
import elipseBlue from "../../assets/icons/ellipse-blue.svg";
import polygon1 from "../../assets/polygons/Polygon 1 (Stroke).svg";
import polygon2 from "../../assets/polygons/Polygon 2 (Stroke).svg";
import polygon3 from "../../assets/polygons/Polygon 3 (Stroke).svg";
import polygon4 from "../../assets/polygons/Polygon 4 (Stroke).svg";
import polygon5 from "../../assets/polygons/Polygon 5 (Stroke).svg";
import polygon6 from "../../assets/polygons/Polygon 6 (Stroke).svg";
import polygon7 from "../../assets/polygons/Polygon 7 (Stroke).svg";
import polygon8 from "../../assets/polygons/Polygon 8 (Stroke).svg";

import { useNavigate } from "react-router-dom";

function formatCurrency(num) {
  return num.toLocaleString("vi-VN") + " đ";
}

function LoanForm() {
  const [loan, setLoan] = useState(3000000);
  const [loanMonth, setLoanMonth] = useState(6);
  const navigate = useNavigate();

  // Giả sử lãi suất 18%/năm, tính tiền góp hàng ngày
  const interestRate = 0.18;
  const days = loanMonth * 30;
  const total = loan + loan * interestRate * (loanMonth / 12);
  const daily = Math.round(total / days);

  // Slider percent helpers for gradient fill
  const minLoan = 3000000;
  const maxLoan = 300000000;
  const minLoanMonth = 6;
  const maxLoanMonth = 24;
  const amountPercent = Math.round(
    ((loan - minLoan) / (maxLoan - minLoan)) * 100
  );
  const loanMonthPercent = Math.round(
    ((loanMonth - minLoanMonth) / (maxLoanMonth - minLoanMonth)) * 100
  );

  function handleGetMoneyClick(e) {
    e.preventDefault();
    navigate("/dich-vu/vay-online/dang-ky-vay", {
      state: { loan, loanMonth },
    });
  }

  return (
    <form className="vayonline-loan-form">
      <div className="vayonline-form-section">
        <label className="vayonline-form-label">
          <span
            style={{
              color: "#344054",
              fontSize: "20px",
              fontFamily: "Roboto",
              fontWeight: "700",
              wordWrap: "break-word",
            }}
          >
            Số tiền bạn cần{" "}
          </span>
          <span
            style={{
              color: "#57C4AD",
              fontSize: "20px",
              fontFamily: "Roboto",
              fontWeight: "700",
              wordWrap: "break-word",
            }}
          >
            vay**
          </span>
        </label>
        <div className="vayonline-amount-display">{formatCurrency(loan)}</div>
        <div className="vayonline-slider-container">
          <input
            type="range"
            min={minLoan}
            max={maxLoan}
            step={1000000}
            value={loan}
            onChange={(e) => setLoan(Number(e.target.value))}
            className="vayonline-slider-bar"
            style={{
              background: `linear-gradient(to right, #2e74d4 0%, #2e74d4 ${amountPercent}%, #E5EDF7 ${amountPercent}%, #E5EDF7 100%)`,
            }}
          />
          <div className="vayonline-slider-track">
            <span className="vayonline-slider-marker">3.000.000đ</span>
            <span className="vayonline-slider-marker">300.000.000đ</span>
          </div>
        </div>
      </div>
      <div className="vayonline-form-section">
        <label className="vayonline-form-label">
          <span
            style={{
              color: "#344054",
              fontSize: "20px",
              fontFamily: "Roboto",
              fontWeight: "700",
              wordWrap: "break-word",
            }}
          >
            Kỳ hạn vay
          </span>
        </label>
        <div className="vayonline-term-display">{loanMonth} tháng</div>

        <div className="vayonline-slider-container">
          <input
            type="range"
            min={minLoanMonth}
            max={maxLoanMonth}
            step={3}
            value={loanMonth}
            onChange={(e) => setLoanMonth(Number(e.target.value))}
            className="vayonline-slider-bar"
            style={{
              background: `linear-gradient(to right, #2e74d4 0%, #2e74d4 ${loanMonthPercent}%, #E5EDF7 ${loanMonthPercent}%, #E5EDF7 100%)`,
            }}
          />
          <div className="vayonline-slider-track">
            <span className="vayonline-slider-marker">6 tháng</span>
            <span className="vayonline-slider-marker">24 tháng</span>
          </div>
        </div>
      </div>
      <div className="vayonline-form-border"></div>

      <div className="vayonline-daily-installment">
        <span className="vayonline-installment-label">
          Dự kiến tiền góp hàng ngày
        </span>
        <div className="vayonline-installment-amount">
          {formatCurrency(daily)}
        </div>
        <div className="vayonline-installment-note">
          *Giá trị chỉ mang tính tham khảo.
          <br /> Khoản vay được xét duyệt sẽ tùy thuộc vào điều kiện và hồ sơ cụ
          thể của từng trường hợp.
        </div>
      </div>
      <button
        className="vayonline-cta-button"
        type="button"
        onClick={handleGetMoneyClick}
      >
        NHẬN TIỀN NGAY
      </button>
    </form>
  );
}

let currentOpen = null;
function FAQItem({ question, answer }) {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    if (currentOpen && currentOpen !== setOpen) {
      currentOpen(false);
    }
    const newState = !open;
    setOpen(newState);
    currentOpen = newState ? setOpen : null;
  };

  return (
    <div className={`faq-item${open ? " open" : ""}`}>
      <div className="faq-question" onClick={handleClick}>
        {question}
        <span className={`faq-arrow${open ? " open" : ""}`}>
          <svg
            width="25"
            height="25"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              transform: open ? "rotate(360deg)" : "rotate(0deg)",
            }}
          >
            <path
              d="M6 8L10 12L14 8"
              stroke="#222"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </div>
      {open && <div className="faq-answer">{answer}</div>}
    </div>
  );
}

const VayOnlinePage = () => {
  return (
    <div className="loan-page">
      <section className="hero-section-vayonline d-flex">
        <div className="container d-flex justify-content-between">
          <div className="hero-content-vayonline">
            <div className="mt-5">
              <div className="hero-subtitle-loan mb-2">
                Giải pháp tài chính ưu việt
              </div>
              <h1 className="hero-title-loan mb-2">
                CẦN TIỀN GẤP HÔM NAY
                <br />
                <span className="hero-title-loan-blue">
                  BLUE-ZONE ỨNG NGAY!
                </span>
              </h1>
              <div className="hero-subtitle-loan-2 mb-2">
                PHÊ DUYỆT NHANH TRONG 15 PHÚT
              </div>
            </div>
            <div className="vayonline-hero-visual">
              <img
                src={require("../../assets/images/smartphone1.png")}
                alt="Người mẫu"
                className="vayonline-hero-model"
              />
            </div>
          </div>
          <div className="form-vayonline d-flex align-items-center justify-content-end">
            <div className="vayonline-loan-form-card">
              <div className="vayonline-form-title">
                Nhập thông tin
                <br /> khoản vay của bạn
              </div>
              <div className="vayonline-form-subtitle">
                Chọn hoặc nhập số tiền để đăng ký khoản vay
              </div>
              <div className="vayonline-form-border"></div>
              <LoanForm />
            </div>
          </div>
        </div>
      </section>

      <section className="features-section">
        <div className="container">
          <div className="features-grid d-flex justify-content-center row mx-0">
            <div className="col-12 col-md-4 col-lg-2">
              <div className="feature-item">
                <div className="feature-icon">
                  <img src={fast} alt="Feature 1" />
                </div>
                <div className="feature-text">
                  Hạn mức tối đa lên đến 100 triệu đồng
                </div>
                <div className="feature-description">
                  Đáp ứng mọi nhu cầu
                  <br />
                  tài chính của bạn
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-2">
              <div className="feature-item">
                <div className="feature-icon">
                  <img src={fastClock} alt="Feature 2" />
                </div>
                <div className="feature-text">
                  Thao tác đăng kí
                  <br />
                  đơn giản
                </div>
                <div className="feature-description">
                  Dễ dàng, nhanh chóng
                  <br /> chỉ trong vài phút
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-2">
              <div className="feature-item">
                <div className="feature-icon">
                  <img src={group} alt="Feature 3" />
                </div>
                <div className="feature-text">
                  Lãi suất ưu đãi
                  <br />
                  12-20%/năm
                </div>
                <div className="feature-description">
                  Tiết kiệm chi phí tối đa <br /> cho khách hàng
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-2">
              <div className="feature-item">
                <div className="feature-icon">
                  <img src={handTouch} alt="Feature 4" />
                </div>
                <div className="feature-text">
                  Duyệt vay siêu tốc
                  <br />
                  Kết quả Online 100%
                </div>
                <div className="feature-description">
                  Nhận kết quả nhanh chóng,
                  <br /> thuận tiện 24/7
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-2">
              <div className="feature-item">
                <div className="feature-icon">
                  <img src={calendar} alt="Feature 5" />
                </div>
                <div className="feature-text">
                  Kì hạn vay
                  <br />
                  linh hoạt
                </div>
                <div className="feature-description">
                  Tối đa lên đến 36 tháng
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-section">
        <img className="about-image" src={aboutUs} alt="About Blue-zone" />
        <div className="about-content">
          <h2 className="about-title">Về chúng tôi</h2>
          <div className="about-subtitle">
            Trao cho bạn một tương lai tài chính vững vàng, ngay KHI BẠN CẦN
          </div>
          <p className="about-description">
            Blue-zone ra đời vào năm 2025 với vai trò là một website cung cấp
            thông tin về các sản phẩm tài chính đầy đủ và cập nhật nhất đến cho
            Khách hàng từ các Ngân hàng và Tổ chức tài chính uy tín tại Việt
            Nam.
            <br />
            <br />
            Blue-zone thực hiện lựa chọn và giới thiệu các sản phẩm tài chính
            phù hợp dựa trên các thông tin được Khách hàng cung cấp,{" "}
            <strong>
              đảm bảo tỷ lệ phê duyệt cao với thủ tục đơn giản, đi kèm nhiều ưu
              đãi độc quyền
            </strong>{" "}
            trên nền tảng công nghệ tiên tiến và thân thiện với người dùng.
          </p>
        </div>
      </section>

      <section className="about-stats">
        <div className="container">
          <div className="stats-container row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4 d-flex justify-content-center">
            <div className="stats-item">
              <img src={moneyOnline} alt="Khách hàng" className="stats-icon" />
              <div className="stats-number">+10.000</div>
              <div className="stats-label">Khách hàng vay tiền</div>
            </div>
            <div className="stats-item">
              <img src={creditCard} alt="Đối tác" className="stats-icon" />
              <div className="stats-number">+3.500</div>
              <div className="stats-label">
                Khách hàng mở thẻ <br /> tín dụng
              </div>
            </div>
            <div className="stats-item">
              <img src={listCheck} alt="Sản phẩm" className="stats-icon" />
              <div className="stats-number">+1.000</div>
              <div className="stats-label">
                Khách hàng tiếp cận <br /> bảo hiểm
              </div>
            </div>
            <div className="stats-item">
              <img src={smile} alt="Kinh nghiệm" className="stats-icon" />
              <div className="stats-number">+10.500</div>
              <div className="stats-label">
                Khách hàng sử dụng lại <br /> dịch vụ
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="partners-section">
        <h2 className="partners-title">Đồng hành các đối tác uy tín</h2>
        <p className="partners-description">
          Blue-zone là đối tác chiến lược của nhiều Ngân hàng và Tổ chức tài
          chính lớn, uy tín khắp Việt Nam
        </p>
        <div className="partners-slider">
          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={40}
            slidesPerView={4}
            navigation
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            loop={true}
            breakpoints={{
              375: {
                slidesPerView: 1,
              },
              640: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 4,
              },
            }}
            // nextButton={<div className="swiper-button-next" />}
            // prevButton={<div className="swiper-button-prev" />}
          >
            <SwiperSlide>
              <div className="image-logo">
                <img src={vinaphone} alt="vinaphone" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={trueMoney} alt="trueMoney" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={feCredit} alt="vinaphone" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={lotte} alt="lotte" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img
                  src={techcombank}
                  alt="techcombank"
                  className="logo-partner"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={tpbank} alt="tpbank" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={vib} alt="vib" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={bidv} alt="bidv" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={f88} alt="f88" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={mobifone} alt="mobifone" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={tpfico} alt="tpfico" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={viettel} alt="viettel" className="logo-partner" />
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </section>

      <section className="borrow-section d-grid justify-content-center">
        <h2 className="services-title">Đối tượng vay</h2>
        <p className="services-description mb-5">
          Ai có thể vay tiền tại Blue-zone?
        </p>
        <div className="borrow-box d-flex align-items-center">
          <div className="col-md-5">
            <img src={borrow} alt="borrow-img" className="borrow-img" />
          </div>

          <div className="col-md-7">
            <div className="d-flex align-items-center mb-4">
              <img
                src={check}
                height={10}
                width={10}
                alt="check-borrow"
                className="check-borrow"
              />
              <div className="borrow-text">
                Công dân Việt Nam từ 18 tuổi trở lên.
              </div>
            </div>
            <div className="d-flex align-items-center mb-4">
              <img
                src={check}
                height={10}
                width={10}
                alt="check-borrow"
                className="check-borrow"
              />
              <div className="borrow-text">
                Sở hữu CMND/CCCD hợp lệ và đăng ký xe chính chủ
                <br /> (nếu vay theo phương tiện).
              </div>
            </div>
            <div className="d-flex align-items-center mb-4">
              <img
                src={check}
                height={10}
                width={10}
                alt="check-borrow"
                className="check-borrow"
              />
              <div className="borrow-text">
                Có thu nhập ổn định để đảm bảo khả năng trả nợ.
              </div>
            </div>
            <div className="d-flex align-items-center mb-4">
              <img
                src={check}
                height={10}
                width={10}
                alt="check-borrow"
                className="check-borrow"
              />
              <div className="borrow-text">
                Sinh sống tại các tỉnh/thành trên toàn quốc.
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="works-section">
        <h2 className="works-title">Quy trình đăng ký vay đơn giản</h2>
        <p className="works-description">
          Thủ tục nhanh gọn, chỉ với 4 bước đơn giản để nhận khoản tiền giải
          ngân sau 15 phút
        </p>
        <div className="works-content">
          <div className="work-one">
            <img src={listForm} alt="listForm" className="listForm" />
            <img src={polygon1} alt="polygon1" className="polygon-1" />
            <div className="line-1"></div>
            <div className="elipse-purple">
              <img src={elipsePurple} alt="" />
            </div>
            <span className="number-one">1</span>
            <span className="text-work-one">
              Điền thông tin
              <br /> đăng ký vay
            </span>
          </div>

          <div className="work-two">
            <img src={telesale} alt="telesale" className="telesale" />
            <img src={polygon2} alt="polygon2" className="polygon-2" />
            <div className="line-2"></div>
            <div className="elipse-green">
              <img src={elipseGreen} alt="" />
            </div>
            <span className="number-two">2</span>
            <span className="text-work-two">
              Nhân viên chăm sóc khách hàng sẽ liên lạc với bạn để tư vấn &
              hướng dẫn chuẩn bị các thủ tục đơn giản, nhanh gọn
            </span>
          </div>

          <div className="work-three">
            <img src={finishForm} alt="finishForm" className="finishForm" />
            <img src={polygon3} alt="polygon3" className="polygon-3" />
            <div className="line-3"></div>
            <div className="elipse-pink">
              <img src={elipsePink} alt="" />
            </div>
            <span className="number-three">3</span>
            <span className="text-work-three">
              Bạn nhận luôn kết quả phê duyệt hoặc cập nhật thông qua Zalo OA
              hoặc website của Blue-zone để hoàn tất thủ tục & ký hồ sơ chỉ
              trong vòng 15 phút
            </span>
          </div>

          <div className="work-four">
            <img src={App} alt="APp" className="app" />
            <img src={polygon4} alt="polygon4" className="polygon-4" />
            <div className="line-4"></div>
            <div className="elipse-blue">
              <img src={elipseBlue} alt="" />
            </div>
            <span className="number-four">4</span>
            <span className="text-work-four">
              <ul>
                <li>Nhận tiền giải ngân thông qua phương thức đã đăng ký</li>
              </ul>
            </span>
          </div>

          <img src={polygon5} alt="polygon5" className="polygon-5" />
          <img src={polygon6} alt="polygon6" className="polygon-6" />
          <img src={polygon7} alt="polygon7" className="polygon-7" />
          <img src={polygon8} alt="polygon8" className="polygon-8" />
          <div className="line"></div>
        </div>
      </section>

      <div className="d-flex justify-content-center">
        <div
          className="info-work d-flex align-items-center rounded-3 py-3 px-3 gap-3 mb-0 w-100"
          role="alert"
        >
          <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-white bg-opacity-50 shadow dots-white">
            <img src={info} alt="info" />
          </div>
          <div className="d-flex flex-column">
            <div className="fw-semibold">Lưu ý quan trọng</div>
            <div className="small mb-0">
              Quá trình giải ngân có thể nhanh hơn tùy thuộc vào tình trạng hồ
              sơ của bạn. Nhân viên tư vấn sẽ hỗ trợ bạn trong suốt quá trình.
            </div>
          </div>
        </div>
      </div>

      <section className="banner-section">
        <div className="banner-home-content">
          <div className="banner-home-logo">
            <img src={logo} alt="banner-logo" />
          </div>
          <h1 className="banner-home-title">
            Đăng ký ngay sản phẩm tài chính phù hợp với nhu cầu của bạn
          </h1>
          <div className="banner-home-description">
            <span>
              Hãy để lại thông tin của mình chính xác đúng và đủ theo yêu cầu,
              nhân viên tư vấn Blue ngay lập tức sẽ liên hệ và kết nối bạn đến
              với sản phẩm tài chính phù hợp nhất
            </span>
          </div>
          <div className="button-banner-home">
            <a href="/lien-he" className="btn-link">
              <button className="button-ban green">
                Liên hệ với chúng tôi
              </button>
            </a>
          </div>
        </div>
      </section>

      <section className="testimonial-section">
        <h2 className="testimonial-title">
          Khách hàng trên 63 tỉnh thành
          <br />
          hài lòng về dịch vụ
        </h2>
        <div className="testimonial-rating">
          <span className="stars">★★★★★</span>
          <span className="score">4.9/5 (437 bình chọn)</span>
        </div>
        <div className="testimonial-cards">
          <div className="testimonial-card">
            <div className="testimonial-stars">★★★★★</div>
            <div className="testimonial-text">
              Tôi cần vốn gấp để nhập hàng kinh doanh, bạn bè tôi biết thì giới
              thiệu vay ở Blue-zone. Lãi suất thì thua rẻ bên nào cũng như nhau,
              cạnh tranh nhau cả, tôi chỉ cần thủ tục nhanh gọn mà minh bạch nên
              chọn Blue-zone và ai cũng gợi ý ở đây. Quy trình đăng ký online
              nhanh chóng, chỉ sau 15 phút là nhân viên liên hệ tư vấn nhiệt
              tình, niềm nở lắm. Tôi còn không mất phí khi tất toán sớm tại
              Blue-zone. Dịch vụ chuyên nghiệp, minh bạch, hỗ trợ tận tình. Tôi
              rất hài lòng!
            </div>
            <div className="testimonial-user">
              <strong>Chị Nguyễn Hoàng Linh</strong>
              <br />
              30 tuổi - Hà Nội
            </div>
          </div>
          <div className="testimonial-card">
            <div className="testimonial-stars">★★★★★</div>
            <div className="testimonial-text">
              Tôi bị mất việc nên cần tiền gấp để trang trải sinh hoạt. Cái tôi
              cần nhất là có thể đăng ký vay online đơn giản, tư vấn nhiệt tình.
              Tôi giãn ngân qua Blue-zone nên mọi thủ tục đều được sớm mà tôi
              không bị tính phí. Đánh giá cho dịch vụ ở Blue-zone vì minh bạch
              và tin cậy!
            </div>
            <div className="testimonial-user">
              <strong>Anh Hoàng Bình Minh</strong>
              <br />
              22 tuổi - Cần Thơ
            </div>
          </div>
          <div className="testimonial-card">
            <div className="testimonial-stars">★★★★★</div>
            <div className="testimonial-text">
              Gia đình tôi cần tiền gấp để chi trả viện phí. Tôi chọn Blue-zone
              vì quy trình vay nhanh chóng, dễ dàng khi gửi tài sản tại tổ chức
              tài chính khác (tôi ưu tiên lựa chọn VPbank vì điểm giao dịch ngay
              gần nhà tôi). Đặc biệt, không mất phí trả nợ trước hạn, rất phù
              hợp với người cần vay ngắn hạn như tôi. Dịch vụ hỗ trợ tận tâm,
              thủ tục minh bạch. Tôi thực sự yên tâm và hài lòng
            </div>
            <div className="testimonial-user">
              <strong>Anh Đỗ Minh Lê</strong>
              <br />
              40 tuổi - Đà Nẵng
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <h2 className="faq-title">Câu hỏi thường gặp về khoản vay Online</h2>
        <div className="faq-list">
          <FAQItem
            question="Làm thế nào để lựa chọn được nền tảng vay online uy tín và an toàn?"
            answer={
              <>
                <span className="text-faq">
                  Để có thể tìm và chọn được một nền tảng vay tiền online uy tín
                  và an toàn bạn cần chú ý một số điều dưới đây:
                </span>
                <span className="text-faq-small">
                  Nghiên cứu và đánh giá: Tìm hiểu về các nền tảng vay tiền
                  online phổ biến trên thị trường. Đọc đánh giá từ người dùng
                  khác và tìm hiểu về danh tiếng của công ty.
                </span>
                <span className="text-faq-small">
                  Kiểm tra thông tin chính thức: Truy cập trang web chính thức
                  của bên cung cấp khoản vay và kiểm tra thông tin về công ty.
                  Xem xét địa chỉ liên hệ, chính sách bảo mật, điều khoản và
                  điều kiện sử dụng dịch vụ.
                </span>
                <span className="text-faq-small">
                  Xác minh đăng ký và giấy phép hoạt động. Đảm bảo rằng nền tảng
                  vay có giấy phép hoạt động hợp pháp từ các cơ quan chính phủ
                  có thẩm quyền. Thông tin này thường được hiển thị trên trang
                  web.
                </span>
                <span className="text-faq-small">
                  Kiểm tra và đánh giá từ người dùng: Tìm hiểu về các đánh giá,
                  phản hồi và kinh nghiệm từ người dùng trước đó, Thông tin này
                  có thể giúp bạn đánh giá tính đáng tin cậy và chất lượng của
                  dịch vụ.
                </span>
                <span className="text-faq-small">
                  Chuẩn bị danh sách câu hỏi: Chuẩn bị một danh sách câu hỏi
                  liên quan đến các chi tiết cụ thể về dịch vụ vay, bao gồm lãi
                  suất, phí, thời gian trả nợ, chính sách hoàn trả, và các điều
                  khoản quan trọng khác.
                </span>
                <span className="text-faq-small">
                  Liên hệ và yêu cầu thông tin: Liên hệ với nền tảng vay thông
                  qua các kênh hỗ trợ khách hàng có sẵn. Đặt các câu hỏi từ danh
                  sách bạn đã chuẩn bị và yêu cầu thông tin cụ thể để làm rõ các
                  điều khoản và điều kiện.
                </span>
                <span className="text-faq-small">
                  So sánh lãi suất và phí: So sánh lãi suất và phí của nền tảng
                  với các dịch vụ vay khác. Đảm bảo rằng các chi phí liên quan
                  đã được nêu rõ và dễ hiểu.
                </span>
                <span className="text-faq-small">
                  Phản ánh với người thân và bạn bè: Hỏi ý kiến của người thân
                  và bạn bè về nền tảng vay mà bạn quan tâm. Đôi khi họ có thể
                  cung cấp những thông tin hoặc gợi ý quý báu.
                </span>
                <span className="text-faq-small">
                  Kiểm tra chứng chỉ bảo mật: Trước khi cung cấp thông tin cá
                  nhân, kiểm tra xem trang web có chứng chỉ bảo mật SSL (Secure
                  Socket Layer) hay không. Biểu tượng khóa và địa chỉ URL bắt
                  đầu bằng https:// là dấu hiệu của trang web an toàn.
                </span>
                <span className="text-faq-small">
                  Khảo sát cẩn thận trước khi đồng ý: Trước khi đồng ý vay tiền,
                  đảm bảo rằng bạn đã đọc kỹ và hiểu rõ tất cả các điều khoản và
                  điều kiện của khoản vay. Nếu có điều gì đó không rõ ràng, hay
                  yêu cầu giải đáp thêm trước khi tiến hành.
                </span>
                <span className="text-faq">
                  <strong className="text-bold">Tóm lại,</strong> việc tìm và
                  chọn một nền tảng vay tiền online uy tín và an toàn đòi hỏi sự
                  cẩn thận và tìm hiểu kỹ lưỡng. Đừng bao giờ đồng ý vay tiền
                  nếu bạn cảm thấy không chắc chắn hoặc có bất kỳ nghi ngờ nào
                  về tính đáng tin cậy của bên cung cấp khoản vay online.
                </span>
              </>
            }
          />
          <FAQItem
            question="Vay tiền online cần những điều kiện gì?"
            answer={
              <>
                <span className="text-faq">
                  Để đủ điều kiện đăng ký các sản phẩm tài chính từ mạng lưới
                  đối tác của Blue-zone, bạn cần chú ý đạt được các điều kiện
                  sau:
                </span>
                <span className="text-faq-small">
                  Bạn cần là công dân Việt Nam, có CMND/CCCD còn hiệu lực
                </span>
                <span className="text-faq-small">
                  Sử dụng số điện thoại là thuê bao chính chủ để đăng ký
                </span>
                <span className="text-faq">
                  Sau đó Blue-zone sẽ dựa vào các thông tin khác mà bạn cung cấp
                  để đề xuất đến bạn sản phẩm phù hợp với khả năng được phê
                  duyệt cao nhất.
                </span>
              </>
            }
          />
          <FAQItem
            question="Cách xác minh danh tính và thông tin cá nhân khi vay tiền online?"
            answer={
              <>
                <span className="text-faq">
                  Để giúp Blue-zone xác minh chính xác danh tính của bạn giúp
                  quá trình phê duyệt được diễn ra dễ dàng và nhanh chóng, bạn
                  cần đăng ký bằng số điện thoại chính chủ đang sở hữu và thực
                  hiện xác thực theo mã OTP 6 số mà Blue-zone gửi về tin nhắn
                  Zalo hoặc tin nhắn điện thoại cho bạn, sau đó khai báo các
                  thông tin đi kèm một cách chính xác.
                </span>
              </>
            }
          />
          <FAQItem
            question="Blue-zone cung cấp khoản vay online có hạn mức tối đa là bao nhiêu?"
            answer={
              <>
                <span className="text-faq">
                  Mạng lưới các đối tác tài chính và sản phẩm Vay online của
                  Blue-zone rất đa dạng. Blue-zone có thể đề xuất và giới thiệu
                  bạn đến các khoản vay nhỏ từ 5.000.000 đồng cho đến khoản vay
                  tín chấp tới 300.000.000 đồng tùy thuộc vào nhu cầu hiện tại
                  của bạn.
                </span>
              </>
            }
          />
        </div>
      </section>
    </div>
  );
};

export default VayOnlinePage;
